import { Component, Input, EventEmitter, Output } from '@angular/core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-success-toaster',
  templateUrl: './success-toaster.component.html',
  styleUrl: './success-toaster.component.scss'
})
export class SuccessToasterComponent {
  @Input() title: string = '';
  @Output() closeToaster: EventEmitter<any> = new EventEmitter<any>()
  delayTime: number = 3000;  //3 seconds
  showToaster: boolean = true;
  faCheckCircle = faCheckCircle;

  constructor() {
    this.startClosingToaster()
  }

  startClosingToaster() {
    setTimeout(() => {
      this.closeToast();
    }, this.delayTime)
  }

  closeToast() {
    this.showToaster = false;
    this.closeToaster.emit(false);
  }

}
